import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';

import { Observable } from 'rxjs';

export class YearInterceptor implements HttpInterceptor {

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Get selected financial year from localStorage
    const yearKey = localStorage.getItem('yearKey');

  console.log('========== YEAR INTERCEPTOR ==========');
    console.log('Request URL:', request.url);
    console.log('Request URL with params BEFORE:', request.urlWithParams);
    console.log('Selected yearKey from localStorage:', yearKey);
    console.log('======================================');
    console.log('Selected yearKey:', yearKey);

    // If yearKey is not available,
    // send request normally
    if (!yearKey) {
      console.log('No yearKey found');
      return next.handle(request);
    }

    // Don't add yearKey to financial-year APIs
    if (
      request.url.includes('/auth/') ||
      request.url.includes('/year/') ||
      request.url.includes('/getAllYear')||
       request.url.includes('/workorder/details/')
    ) {
       console.log('WORKORDER DETAILS - SKIPPING YEAR INTERCEPTOR');
  console.log('URL:', request.urlWithParams);
      return next.handle(request);
    }

    // Add yearKey automatically to API request
    // const modifiedRequest = request.clone({
    //   setParams: {
    //     yearKey: yearKey
    //   }
    // });
    const modifiedRequest = request.clone({
  setParams: request.params.has('yearKey')
    ? {}
    : {
        yearKey: yearKey
      }
});

    // console.log(
    //   'Modified URL:',
    //   modifiedRequest.urlWithParams
    // );

    return next.handle(modifiedRequest);
  }
}
